import { render, staticRenderFns } from "./EducationOutput.vue?vue&type=template&id=11dca344"
import script from "./EducationOutput.vue?vue&type=script&lang=js"
export * from "./EducationOutput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports